export default __webpack_public_path__ + "static/media/nftfloorprice-logo.ffc5ac10.svg";